import { FC, useCallback } from 'react';

import { useTranslations } from 'context/translations';
import { LandingPageContentKeys, LandingPageTextKeys } from 'service';

import styles from './PersonalHealthCoachBlock.module.css';

export const PersonalHealthCoachBlock: FC = () => {
  const { content, t } = useTranslations();

  const renderImages = useCallback(() => {
    return content(LandingPageContentKeys.PersonalBlockContent).map(
      ({ text }) => (
        <img loading="lazy" key={text} src={text} alt="screenshot" />
      ),
    );
  }, [content]);

  return (
    <div className={styles.container}>
      <div className={styles.title_container}>
        <div>{t(LandingPageTextKeys.PersonalBlockHeader)}</div>
        <h1>{t(LandingPageTextKeys.PersonalBlockTitle)}</h1>
        <div>{t(LandingPageTextKeys.PersonalBlockDescription)}</div>
      </div>

      <div className={styles.image_container}>{renderImages()}</div>

      <div className={styles.card_container}>
        <div className={styles.card_container_column}>
          <div>
            <div>{t(LandingPageTextKeys.PersonalBlockCard0Title)}</div>
            <div>{t(LandingPageTextKeys.PersonalBlockCard0Description)}</div>
          </div>
          <div>
            <div>{t(LandingPageTextKeys.PersonalBlockCard1Title)}</div>
            <div>{t(LandingPageTextKeys.PersonalBlockCard1Description)}</div>
          </div>
        </div>
        <div className={styles.card_container_column}>
          <div>
            <div>{t(LandingPageTextKeys.PersonalBlockCard2Title)}</div>
            <div>{t(LandingPageTextKeys.PersonalBlockCard2Description)}</div>
          </div>
          <div>
            <div>{t(LandingPageTextKeys.PersonalBlockCard3Title)}</div>
            <div>{t(LandingPageTextKeys.PersonalBlockCard3Description)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
